/**
 * Created by tofael on 9/3/18.
 */
import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import UplodIcon from 'material-ui/svg-icons/action/backup';

const FileChooser = ({label="Select Files", showIcon= true, style, onSelect}) => {
  return (
      <RaisedButton
        containerElement="label"
        icon={showIcon ? <UplodIcon/> : null} // material-ui-icons
        label={label}
        primary={true}
        style={style}>
        <input
          multiple={true}
          onChange={e => onSelect(e)}
          style={{ display: 'none' }}
          type="file"
          accept=".jpg,.png,.jpeg,.pdf"
        />
      </RaisedButton>
  );
};

export default FileChooser;


// WEBPACK FOOTER //
// ./src/screens/shared/file-upload/file-chooser.js